export const USER_SUBMITTER = 'Second Party';
export const ADMIN_SUBMITTER = 'First Party';
